module.exports = __webpack_public_path__ + "img/playstore.740f59b1.png";